import CommonContentTable, {
  ProcessedHeadline,
} from 'common/components/entities/ContentTable'
import { getProcessedHeadlines } from 'common/components/entities/ContentTable/utils'
import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import useManagement from 'publisher/hooks/useManagement'
import { managementSelectors, usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React, { useEffect, useState } from 'react'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'

function ContentTable({ entity }: { entity: ContentTableInterface }) {
  const isDesktop = useManagement(managementSelectors.isDesktop)
  const headings = usePage(page =>
    pageSelectors.getOrderedByPositionHeadings(page, !isDesktop),
  )

  const { calculatedFontFamily } = useCalculateTypography({
    fontFamily: entity.headerFontFamily,
  })
  const defaultState =
    typeof entity.isOpenedByDefault === 'boolean'
      ? !entity.isOpenedByDefault
      : false

  const [processedHeadlines, setProcessedHeadlines] = useState<
    ProcessedHeadline[]
  >([])

  useEffect(() => {
    setProcessedHeadlines(
      getProcessedHeadlines({
        headings,
        entity,
        isClient: false,
      }),
    )
  }, [])

  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonContentTable
        iconClassName={entity.iconClassName}
        closedIconClassName={
          entity.closedIconClassName && entity.closedIconClassName
        }
        defaultState={defaultState}
        iconColor={entity.iconColor}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        processedHeadlines={processedHeadlines}
        headerFontFamily={calculatedFontFamily.desktop}
        headerFontStyle={entity.headerFontStyle}
        headerFontWeight={entity.headerFontWeight}
        contentColor={entity.contentColor}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        headerTitle={entity.headerTitle}
        headerFontSize={entity.headerFontSize}
        headerColor={entity.headerColor}
        contentFontSize={entity.contentFontSize}
        contentFontFamily={entity.contentFontFamily}
        contentFontStyle={entity.contentFontStyle}
        contentFontWeight={entity.contentFontWeight}
        contentItemGap={entity.contentItemGap}
      />
    </StyleWrapper>
  )
}

export default ContentTable
